import React, { createContext, useState, useContext, Dispatch, SetStateAction } from "react";

export interface GlobalStateInterface {
    summary: any[];
    annotations: any[];
    total: number;
}

const GlobalStateContext = createContext<{
    state: GlobalStateInterface;
    setState: Dispatch<SetStateAction<GlobalStateInterface>>;
}>({
    state: { summary: [], annotations: [], total: 0 },
    setState: () => {},
});

const GlobalStateProvider = ({children, value = { summary: [], annotations: [], total: 0 }}: {
    children: React.ReactNode;
    value?: GlobalStateInterface;
}) => {
    const [state, setState] = useState<GlobalStateInterface>(value);
    return (
        <GlobalStateContext.Provider value={{ state, setState }}>
            {children}
        </GlobalStateContext.Provider>
    );
};

const useGlobalState = () => {
    const context = useContext(GlobalStateContext);
    if (!context) {
        throw new Error('No GlobalStateContext! UseGlobalState must be used within a GlobalStateContext!');
    }
    return context;
};

export { GlobalStateProvider, useGlobalState };
